/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CheckCompanyDomainExistsQueryResponse,
  CheckCompanyDomainExistsQueryParams,
} from '../types/CheckCompanyDomainExists'

function getCheckCompanyDomainExistsUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/contacts/companies-search/domain/` as const,
  }
  return res
}

/**
 * @summary Check whether a domain already exists on any company or chain
 * {@link /api/v1/contacts/companies-search/domain/}
 */
export async function checkCompanyDomainExists(
  params: CheckCompanyDomainExistsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    CheckCompanyDomainExistsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getCheckCompanyDomainExistsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
